<template>
    <div>
        <div class="mb-3">
            <label for="product_group">Product group</label>
            <select
                v-model="product.product_group_id"
                id="product_group"
                class="form-control w-auto mb-3"
                @click="selectingProductGroup()"
                @change="linkProductGroup()"
            >
                <option :value="null">None</option>
                <option
                    v-for="productGroup in productGroups"
                    :key="productGroup.id"
                    :value="productGroup.id"
                >
                    {{ productGroup.name }}
                </option>
            </select>
        </div>
        <div class="alert alert-info" v-if="product.product_group &&
            product.product_group.variation_attribute_ids.filter((id) => !product.attributeValues.find((attribute) => attribute.id == id)).length">
            <i class="la la-info-circle mr-2"></i>
            This product will not yet be visible on front: all the attributes used for variation need to have a value
        </div>
        <div><label>Attributes / variations</label></div>
        <div
            v-for="(attribute, index) in product.attributeValues"
            :key="index"
            class="border mb-3 p-2"
        >
            <div class="d-flex bg-white">
                <div class="mr-auto cursor-pointer" @click="openFormAttribute(attribute)">
                    <span class="font-weight-bold mr-2">
                        {{ attribute.name }}
                        <span class="mr-1"
                        v-if="product.product_group && product.product_group.variation_attribute_ids.find((id) => id == attribute.id)"
                        >(used for variation)</span>
                    </span>
                    <span v-if="!formEditAttribute || formEditAttribute.id != attribute.id">
                        <!-- {{ _.join(_.map(attribute.values, "name"), ", ") }} -->
                        <span v-if="attribute.type == 'multi'">
                            <span v-for="value in attribute.values" :key="value.id" class="mr-2">{{value.name}} {{attribute.unitName}}</span>
                        </span>
                        <span v-else-if="attribute.type == 'numeric'">
                            {{attribute.numeric_value}} {{attribute.unitName}}
                        </span>
                        <span v-else-if="attribute.type == 'boolean'">
                            {{attribute.boolean_value ? 'Yes' : 'No'}}
                        </span>
                        <i class="la la-pencil ml-2"></i>
                    </span>
                </div>
                <div>
                    <div
                        class="cursor-pointer text-danger"
                        @click="deleteAttribute(attribute.id)"
                    >
                        <i class="la la-trash"></i> Delete
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div
                    v-if="formEditAttribute && formEditAttribute.id == attribute.id"
                    class="p-3"
                >
                    <div v-if="attribute.type == 'multi'">
                        <div v-if="product.product_group && product.product_group.variation_attribute_ids.find((id) => id == attribute.id)">
                            <select v-model="attribute.values[0]" class="form-control w-auto mb-3">
                                <option :value="value" v-for="value in attribute.possible_values" :key="value.id">{{value.name}}</option>
                            </select>
                        </div>
                        <div v-else>
                            <label
                                :for="value.name"
                                v-for="value in attribute.possible_values"
                                :key="value.id"
                                class="mr-3"
                            >
                                <input
                                    type="checkbox"
                                    :id="value.name"
                                    :value="value"
                                    v-model="attribute.values"
                                />
                                {{ value.name }} {{attribute.unitName}}
                            </label>
                        </div>
                        <div class="mb-3">
                            <label>Create new value</label>
                            <div class="input-group input-group-sm w-25">
                                <input type="text" v-model="newValue" class="form-control">
                                <div v-if="attribute.unitName" class="input-group-append">
                                    <span class="input-group-text">{{attribute.unitName}}</span>
                                </div>
                                <div class="input-group-append">
                                    <div class="btn btn-secondary" @click="createValue(attribute)">Create</div>
                                </div>
                            </div>
                        </div>
                        <div class="btn btn-primary" @click="updateAttribute(attribute)">Save</div>
                    </div>
                    <div v-else-if="attribute.type == 'numeric'">
                        <div class="input-group input-group w-25 mb-3">
                            <input type="text" v-model.number="attribute.numeric_value" class="form-control">
                            <div v-if="attribute.unitName" class="input-group-append">
                                <span class="input-group-text">{{attribute.unitName}}</span>
                            </div>
                        </div>
                        <div class="btn btn-primary" @click="setValue(attribute, 'edit')">Save</div>
                    </div>
                    <div v-else-if="attribute.type == 'boolean'">
                        <select v-model="attribute.boolean_value" class="form-control w-auto mb-3">
                            <option :value="1">Yes</option>
                            <option :value="0">No</option>
                        </select>
                        <div class="btn btn-primary" @click="setValue(attribute, 'edit')">Save</div>
                    </div>
                </div>
            </transition>
        </div>
        <transition name="fade">
            <div
                class="mb-3 p-3 border"
                v-if="showFormAddAttribute && product.possibleAttributes.length"
            >
                <label for="attribute">Add attribute</label>
                <select
                    v-model="selectedAttribute"
                    id="attributes"
                    class="form-control w-auto mb-3"
                >
                    <option
                        v-for="existingAttribute in product.possibleAttributes"
                        :key="existingAttribute.id"
                        :value="existingAttribute"
                    >
                        {{ existingAttribute.name }}
                        <span class="mr-1"
                        v-if="product.product_group && product.product_group.variation_attribute_ids.find((id) => id == existingAttribute.id)"
                        >(used for variation)</span>
                    </option>
                </select>
                <div v-if="selectedAttribute">
                    <div v-if="selectedAttribute.type == 'multi'">
                        <div v-show="selectedAttribute.possible_values.length">
                            <div v-if="product.product_group && product.product_group.variation_attribute_ids.find((id) => id == selectedAttribute.id)">
                                <label class="d-block">Value:</label>
                                <select v-model="selectedValues[0]" class="form-control w-auto mb-3">
                                    <option :value="value.id" v-for="value in selectedAttribute.possible_values" :key="value.id">{{value.name}}</option>
                                </select>
                            </div>
                            <div v-else>
                                <label class="d-block">Values:</label>
                                <label
                                    :for="value.name"
                                    v-for="value in selectedAttribute.possible_values"
                                    :key="value.id"
                                    class="mr-3"
                                >
                                    <input
                                        type="checkbox"
                                        :id="value.name"
                                        v-model="selectedValues"
                                        :value="value.id"
                                    />
                                    {{ value.name }} {{selectedAttribute.unitName}}
                                </label>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label>Create new value</label>
                            <div class="input-group input-group-sm w-25">
                                <input type="text" v-model="newValue" class="form-control">
                                <div v-if="selectedAttribute.unitName" class="input-group-append">
                                    <span class="input-group-text">{{selectedAttribute.unitName}}</span>
                                </div>
                                <div class="input-group-append">
                                    <div class="btn btn-secondary" @click="createValue(selectedAttribute)">Create</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedValues.length" class="btn btn-primary" @click="addAttribute">
                            Add
                        </div>
                    </div>
                    <div v-else-if="selectedAttribute.type == 'numeric'">
                        <div class="input-group input-group w-25 mb-3">
                            <input type="text" v-model.number="newValue" class="form-control">
                            <div v-if="selectedAttribute.unitName" class="input-group-append">
                                <span class="input-group-text">{{selectedAttribute.unitName}}</span>
                            </div>
                        </div>
                        <div class="btn btn-primary" @click="setValue(selectedAttribute, 'add')">Save</div>
                    </div>
                    <div v-else-if="selectedAttribute.type == 'boolean'">
                        <select v-model="newValue" class="form-control w-auto mb-3">
                            <option :value="1">Yes</option>
                            <option :value="0">No</option>
                        </select>
                        <div class="btn btn-primary" @click="setValue(selectedAttribute, 'add')">Save</div>
                    </div>
                </div>
            </div>
        </transition>
        <div
            class="btn btn-primary mt-2"
            v-if="product.possibleAttributes.length"
            @click="showFormAddAttribute = !showFormAddAttribute; selectedAttribute = null; formEditAttribute = null"
        >
            <i class="la la-plus"></i> Add an attribute
        </div>
        <div v-else>
            In order to add attributes to this product, you need to create
            them first, <a href="/admin/attribute">click here</a>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
    data() {
        return {
            product: product,
            productGroups: productGroups,
            showFormAddAttribute: false,
            selectedAttribute: null,
            selectedValues: [],
            formEditAttribute: null,
            formEditValueId: null,
            formAddValueOpened: false,
            newValue: null,
        };
    },
    methods: {
        selectingProductGroup() {
            this.selectedAttribute = null
            this.selectedValues = []
            this.showFormAddAttribute = false
        },
        linkProductGroup() {
            axios
                .post("/admin/ajax/product-group/link", {
                    product_group_id: this.product.product_group_id,
                    product_id: this.product.id,
                    locale: locale
                })
                .catch((error) => {
                    new Noty({
                        type: "error",
                        text: "Operation failed",
                    }).show();
                })
                .then((response) => {
                    this.product = response.data;

                    new Noty({
                        type: "success",
                        text: "Product group saved",
                    }).show();
                });
        },
        possibleNewValues: function (attribute) {
            return attribute.possible_values.filter(
                (v) => !attribute.values.find((val) => v.id == val.id)
            );
        },
        openFormAddValue(attribute_id) {
            this.formEditValueId = null
            this.formAddValueOpened =
                this.formAddValueOpened == attribute_id
                    ? null
                    : attribute_id
        },
        openFormAttribute(attribute) {
            this.formEditAttribute =
            this.formEditAttribute && this.formEditAttribute.id == attribute.id ? null : attribute;
            this.formEditValueId = null;
            this.showFormAddAttribute = false;
        },
        openFormValue(id) {
            this.formAddValueOpened = null
            this.formEditValueId = this.formEditValueId == id ? null : id;
        },
        addAttribute() {
            axios
                .post("/admin/ajax/attribute/add", {
                    product_id: this.product.id,
                    attribute_id: this.selectedAttribute.id,
                    value_ids: this.selectedValues,
                    locale: locale
                })
                .catch((error) => {
                    new Noty({
                        type: "error",
                        text: "Operation failed",
                    }).show();
                })
                .then((response) => {
                    this.product = response.data;

                    new Noty({
                        type: "success",
                        text: "Attribute  added!",
                    }).show();

                    this.selectedAttribute = null
                    this.selectedValues = []
                    this.showFormAddAttribute = false
                });
        },
        createValue(attribute) {
            if (this.newValue) {
                axios
                    .post("/admin/ajax/value/create", {
                        product_id: this.product.id,
                        attribute_id: attribute.id,
                        value: this.newValue,
                        locale: locale
                    })
                    .catch((error) => {
                        new Noty({
                            type: "error",
                            text: "Operation failed",
                        }).show();
                    })
                    .then((response) => {
                        this.product = response.data;

                        new Noty({
                            type: "success",
                            text: "Value created!",
                        }).show();

                        if (this.selectedAttribute) {
                            this.selectedAttribute = this.product.possibleAttributes.find((attr) => attr.id == attribute.id)
                        } else {
                            this.formEditAttribute = attribute
                        }

                        this.newValue = null
                    });
            }
        },
        setValue(attribute, action) {
            var type = attribute.type
            var value = action == 'edit' ? attribute[type+'_value'] : this.newValue
            if (type == 'numeric' || type == 'boolean') {
                axios
                    .post("/admin/ajax/value/create", {
                        product_id: this.product.id,
                        attribute_id: attribute.id,
                        value: value,
                        locale: locale
                    })
                    .catch((error) => {
                        new Noty({
                            type: "error",
                            text: "Operation failed",
                        }).show();
                    })
                    .then((response) => {
                        this.product = response.data;

                        new Noty({
                            type: "success",
                            text: "Value created!",
                        }).show();

                        this.showFormAddAttribute = false
                        this.selectedAttribute = null
                        this.formEditAttribute = null
                        this.newValue = null
                    });
            }
        },
        updateAttribute(attribute) {
            axios
                .post("/admin/ajax/attribute/update", {
                    product_id: this.product.id,
                    attribute_id: attribute.id,
                    value_ids: attribute.values.map(value => value.id),
                    locale: locale
                })
                .catch((error) => {
                    new Noty({
                        type: "error",
                        text: "Operation failed",
                    }).show();
                })
                .then((response) => {
                    this.product = response.data;

                    new Noty({
                        type: "success",
                        text: "Attribute  saved!",
                    }).show();

                    this.selectedAttribute = null
                    this.showFormAddAttribute = false
                    this.formEditAttribute = null
                });
        },
        deleteAttribute(attribute_id) {
            axios
                .post("/admin/ajax/attribute/delete", {
                    product_id: this.product.id,
                    attribute_id: attribute_id,
                    locale: locale
                })
                .catch((error) => {
                    new Noty({
                        type: "error",
                        text: "Operation failed",
                    }).show();
                })
                .then((response) => {
                    this.product = response.data;
                    new Noty({
                        type: "success",
                        text: "Attribute deleted!",
                    }).show();
                });
        },
    },
    components: {
        draggable,
    },
};
</script>
